import React from 'react';
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.css';
import App from './App';
import store from './store'
import reportWebVitals from './reportWebVitals';
import LanguageWrapper from './components/context/LanguageWrapper'

const container = document.getElementById('root')
const root = createRoot(container);

root.render(
  <LanguageWrapper>
    <Provider store={store}>
      <App />
    </Provider>
  </LanguageWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
